import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import DatePicker from 'react-date-picker';

import './SalesReport.scss';

class SalesReport extends Component{
  constructor(props){
    super(props);

    this.state = {
      zones    :   [],
      zone :   {},
      customers : [],
      showing_customers:[],
      categories    :   [],
      category :   {},
      search:'',
      from_date : new Date(),
      to_date : new Date(),
      minDate : new Date(new Date().getFullYear()-1, new Date().getMonth(), 1 ),
      maxDate : new Date(new Date().getFullYear(), new Date().getMonth()+1, 0),
    }
    this.zoneChange = this.zoneChange.bind(this);
    this.formChange = this.formChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);


  }
  componentDidMount(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/get/mappedZones`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          zones : return_data.zone_mapped,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
   }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
        obj_this.props.history.replace("/");
    });

    const url3 = `${process.env.REACT_APP_SSS}/api/get/productCategories`;
    this.context.loading(1);
    $.ajax({
      url : url3,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         categories : return_data.categories,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
   }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
        obj_this.props.history.replace("/");
    });

    // var obj_this = this;
    // const url2 = `${process.env.REACT_APP_SSS}/api/reports/getSalesreport`;
    // this.context.loading(1);
    // $.ajax({
    //   url : url2,
    //   data : {
    //     sid : this.context.user_details.sid,
    //   },
    //   type : "POST"
    // }).done(function(return_data){
    //   console.log(return_data);
    //   // customers = customers.sort(function(a,b){
    //   //   return a.no_due - b.no_due
    //   // });
    //   // return;
      
    //   if(return_data.status == "success"){
    //     obj_this.setState({
    //      customers : return_data.customers,
    //      showing_customers:return_data.customers
    //     });
    //     // debugger;
    //     obj_this.context.loading(0);
    //   }else{
    //     obj_this.context.loading(0);
    //     obj_this.props.history.replace("/");
    //   }
    // }).fail(function(){
    //   alert("Network error");
    //   obj_this.context.loading(0);

    // });

    
  }

  formChange(e){
    // console.log(e.target.value);
    var showing_schedule =[];
    if(e.target.value){
      showing_schedule = this.state.showing_customers.filter((item) => {return item.name.toLowerCase().includes(e.target.value.toLowerCase())});
    }
    else{
      showing_schedule = this.state.customers;
    }
    // showing_customers = showing_customers.length?showing_customers:this.state.doc_name;
    this.setState({
      showing_customers : showing_schedule
    });
  }

  zoneChange(option){
    this.setState({
      zone : option
    });
  } 
  categoryChange(option){
    this.setState({
      category : option
    });
  }  

  formSubmit(e){
    e.preventDefault();
    $(".customer_outstandings_table tr").css("backgroud-color","");
  
    
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/reports/getSalesreport`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        zone_id : this.state.zone.value,
        from_date : this.state.from_date.toLocaleDateString('en-CA'),
        to_date : this.state.to_date.toLocaleDateString('en-CA'),
        category_id : this.state.category.value
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // customers = customers.sort(function(a,b){
      //   return a.no_due - b.no_due
      // });
      // return;
      
      if(return_data.status == "success"){
        obj_this.setState({
         customers : return_data.customers,
         showing_customers:return_data.customers,
         tot_qty  : return_data.tot_qty,
         tot_sale  : return_data.tot_sale,
        });
        // debugger;
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
   
    
  }


  fromDateChange(value){
    // console.log(value);
    this.setState({from_date : value});
  }
  toDateChange(value){
    // console.log(value);
    this.setState({to_date : value});
  }



  
    

  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="sales_report_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Sales Report</div>
          </div> 
          <form className="executive_due_period_form" onSubmit={this.formSubmit}>
            <div className="blocks">
              <div className="input_grid">
                <div className="form_input">
                  <div className="from_to_label">
                    <div className="input_label">From Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.fromDateChange(value)}
                      value={this.state.from_date}
                      minDate = {this.state.minDate}
                      maxDate = {this.state.maxDate}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                    <div className="input_label">To Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.toDateChange(value)}
                      value={this.state.to_date}
                      minDate = {new Date(this.state.from_date)}
                      maxDate = {this.state.maxDate}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                  </div>
                  <div className="input_label">Product Category</div>
                  <Select 
                    options={this.state.categories}  
                    value ={this.state.category}
                    className="executive" 
                    onChange={e => this.categoryChange(e)}
                  />
                   <div className="input_label">Zones</div>
                  <Select 
                    options={this.state.zones}  
                    value ={this.state.zone}
                    className="executive" 
                    onChange={e => this.zoneChange(e)}
                  />
                  <div className="submit_button_container">
                    <button className="submit_button">Submit</button>
                  </div>
                </div>
                
                </div>
                
            </div>
          </form>
          <div className="search_container">
            <CgSearch/>
            <input className="customer_search_input" 
              placeholder="Search Customers.."
              onChange={this.formChange}
              value={this.search}
            />
          </div>
          <div className="table_container">
            <table className="customer_outstandings_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th>Customer</th>
                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.showing_customers.length?"none":"table-row"}}>
                <td colSpan="2" align="center">No result!</td>
              </tr>
              {this.state.showing_customers && this.state.showing_customers.map((cust,index) => (
                <tr key={index}  style={{backgroundColor:cust.pending_total>0 && !cust.no_due?"#ffa8b3":""}}>
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top" style={{padding:"5px 0px"}}>
                    <div style={{fontWeight:"500",paddingLeft:"5px"}}>{cust.name}</div>
                    <div className="bills_table_container" style={{display:cust.sale_report.length?"block":"none"}}>
                      <table className="bills_table">
                        <thead>
                          <tr>
                            <th>Product Category</th>
                            <th>Qty</th>
                            <th>Unit Price</th>
                            <th>Total Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cust.sale_report && cust.sale_report.map((bill,idx) => (
                          <tr key={idx}>
                            <td>{bill.category_name}</td>
                            <td>
                              <span>{bill.qty}</span>
                            </td>
                            <td>
                              <span>{parseFloat(bill.cat_total/bill.qty).toFixed(3)}</span><span style={{marginLeft:"3px"}}>{this.context.currency}</span>
                            </td>
                            <td style={{textAlign:"center"}}>
                              <span>{bill.cat_total}</span>
                              <span style={{marginLeft:"3px"}}>{this.context.currency}</span>
                            </td>
                          </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
            <table className="customer_outstandings_table">
              <tbody style={{fontSize:'15px',fontWeight: '900'}}>
                <tr style={{display:this.state.tot_qty>0||this.state.tot_sale>0?"table-row":"none"}}>
                  <td align="center" style={{fontSize:'12px',fontWeight:"800"}}> Total Qty : {this.state.tot_qty} </td>
                  <td align="center" style={{fontSize:'12px',fontWeight:"800"}}>Total Price : {this.state.tot_sale} <span style={{marginLeft:"3px"}}>{this.context.currency}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default SalesReport;
SalesReport.contextType = MyContext;
